module.exports = __webpack_public_path__ + "img/accessories.0d36c9f8.svg";